import { FC, ReactNode, useState } from 'react';
import { Button, ButtonProps } from '@/components/ui/button';
import {
	Dialog,
	DialogContent,
	DialogTitle,
	DialogDescription,
	DialogHeader,
	DialogFooter,
	DialogClose,
} from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import Cancel_01_Icon from '@/components/icons/Cancel_01_Icon';
import useMediaQuery from '@/hooks/useMediaQuery';
import { AppConfig } from '@/config/app.config';

type Props = {
	label: string;
	description: string;
	submitName?: string;
	submitVariant?: ButtonProps['variant'];
	onSubmit: () => void;
	closeName?: string;
	closeVariant?: ButtonProps['variant'];
	onClose: () => void;
	buttonsContainerClassName?: string;
	buttonsRender?: ReactNode;
};

const EInfoModal: FC<Props> = ({
	label,
	description,
	submitName = 'Submit',
	submitVariant = 'default',
	onSubmit,
	closeName = 'Cancel',
	closeVariant = 'outline',
	onClose,
	buttonsContainerClassName,
	buttonsRender,
}) => {
	const [isOpen, setIsOpen] = useState(true);

	const isMobile = useMediaQuery(AppConfig.mediaQueries.mobile);

	const handleClose = () => {
		setIsOpen(false);
		setTimeout(onClose, 300);
	};

	return (
		<Dialog
			open={isOpen}
			onOpenChange={handleClose}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>
						{label}
						<DialogClose
							className={cn(
								'ml-auto flex items-center justify-center cursor-pointer',
								isMobile &&
									'size-11 border border-popover-100 rounded-full',
							)}>
							<Cancel_01_Icon />
						</DialogClose>
					</DialogTitle>
				</DialogHeader>
				<div className='flex flex-col gap-4'>
					<DialogDescription>{description}</DialogDescription>
				</div>
				<DialogFooter
					className={cn(
						'justify-end',
						isMobile && 'mt-auto',
						buttonsContainerClassName,
					)}>
					{buttonsRender ?? (
						<>
							<Button
								variant={closeVariant}
								onClick={handleClose}
								className='max-w-1/2'>
								<span className='truncate text-inherit'>
									{closeName}
								</span>
							</Button>
							<Button
								variant={submitVariant}
								onClick={onSubmit}
								className='max-w-1/2'>
								<span className='truncate text-inherit'>
									{submitName}
								</span>
							</Button>
						</>
					)}
				</DialogFooter>
			</DialogContent>
		</Dialog>
	);
};

export default EInfoModal;
